/**
 * Created by afuhr on 20.09.2016.
 */
import {
  INITIAL_STATE,
  TempWithdrawalCacheFactory,
  TempWithdrawalFactory,
  TempWithdrawnStockFactory
} from "./scans.initial-state";
import {IPayloadAction} from "../../shared/actions/index";
import {WithdrawalActions} from "./scans.actions";
import {TempWithdrawal, TempWithdrawalCacheRecord} from "./scans.types";
import {INITIAL_USER_STATE} from "../../shared/redux-store/session/session.initial-state";

export function withdrawalReducer(state: TempWithdrawalCacheRecord = INITIAL_STATE,
                                  action: IPayloadAction): TempWithdrawalCacheRecord {

  let newState: TempWithdrawalCacheRecord = JSON.parse(JSON.stringify(state));
  let activeWithdrawal: TempWithdrawal = newState.withdrawalList.find(wd => wd.cuid === (action.payload && action.payload.withdrawal_id ? action.payload.withdrawal_id : state.activeWithdrawalCuid));

  switch (action.type) {
    case WithdrawalActions.CREATE_WITHDRAWAL:
      let newWd: TempWithdrawal = TempWithdrawalFactory(action.payload).toJS();
      newState.withdrawalList.push(newWd);

      return TempWithdrawalCacheFactory(newState);

    case WithdrawalActions.SET_ACTIVE_WITHDRAWAL:
      return state.merge({
        activeWithdrawalCuid: action.payload
      });

    case WithdrawalActions.SET_NOTE:
      activeWithdrawal.withdrawal_note = action.payload.note;
      return TempWithdrawalCacheFactory(newState);

    case WithdrawalActions.SELECT_CONSUMER:
      newState.withdrawalList.map(wd => {
        if (wd.cuid == action.payload.withdrawal_id) {
          wd.consumer_id = action.payload.consumer.consumer_id;
          wd.consumer_type = action.payload.consumer.consumer_type;
          wd.consumer = action.payload.consumer.consumer;
        }
        return wd;
      });

      return TempWithdrawalCacheFactory(newState);

    case WithdrawalActions.SELECT_USER_INIT:
      activeWithdrawal.authenticated_user = INITIAL_USER_STATE;
      activeWithdrawal.personal_number = action.payload.personal_number;
      activeWithdrawal.signature = action.payload.signature;

      return TempWithdrawalCacheFactory(newState);

    case WithdrawalActions.SELECT_USER_SUCCESS:
      activeWithdrawal.authenticated_user = action.payload.user;

      return TempWithdrawalCacheFactory(newState);

    case WithdrawalActions.SELECT_USER_ERROR:
      activeWithdrawal.authenticated_user = null;

      return TempWithdrawalCacheFactory(newState);

    case WithdrawalActions.SELECT_REASON:
      newState.withdrawalList.map(wd => {
        if (wd.cuid == action.payload.withdrawal_id) {
          wd.withdrawal_reason = action.payload.reason.withdrawal_reason;
          wd.withdrawal_reason_type = action.payload.reason.withdrawal_reason_type;
          wd.withdrawal_reason_id = action.payload.reason.withdrawal_reason_id;
        }
        return wd;
      });

      return TempWithdrawalCacheFactory(newState);

    case WithdrawalActions.WITHDRAW_STOCK:

      if (!activeWithdrawal) {
        return state;
      }

      let stock = activeWithdrawal.withdrawn_stocks.find(st => st.stock.cuid === action.payload.stock.cuid);

      if (stock) {
        stock.amount += parseInt((action.payload.amount ? action.payload.amount : 1));
      } else {
        activeWithdrawal.withdrawn_stocks.push(TempWithdrawnStockFactory(action.payload).toJS());
      }

      return TempWithdrawalCacheFactory(newState);


    case WithdrawalActions.CHANGE_STOCK_AMOUNT:

      if (!activeWithdrawal) {
        return state;
      }

      stock = activeWithdrawal.withdrawn_stocks.find(st => st.cuid === action.payload.stock.cuid);

      if (stock) {
        stock.amount = parseInt(action.payload.amount);
      }

      return TempWithdrawalCacheFactory(newState);

    case WithdrawalActions.REMOVE_STOCK_FROM_WITHDRAWAL:

      if (!activeWithdrawal) {
        return state;
      }

      let stockId = activeWithdrawal.withdrawn_stocks.findIndex(st => st.cuid === action.payload.stock.cuid);

      if (stockId >= 0) {
        activeWithdrawal.withdrawn_stocks.splice(stockId, 1);
      }

      return TempWithdrawalCacheFactory(newState);

    case WithdrawalActions.COMMIT_WITHDRAWALS_INIT:
      return state.merge({
        is_committing: true,
        has_errored: false
      });

    case WithdrawalActions.COMMIT_WITHDRAWALS_SUCCESS:
      return state.merge({
        is_committing: false,
        has_errored: false
      });

    case WithdrawalActions.COMMIT_WITHDRAWALS_ERROR:
      return state.merge({
        is_committing: false,
        has_errored: true
      });

    case WithdrawalActions.COMMIT_WITHDRAWAL_SUCCESS:

      let index = newState.withdrawalList.findIndex(wd => wd.cuid == action.payload.withdrawal_id);

      if (newState.withdrawalList[index] && newState.withdrawalList[index].cuid == newState.activeWithdrawalCuid) {
        newState.activeWithdrawalCuid = null;
      }

      if (index > -1) {
        newState.withdrawalList.splice(index, 1);
      }

      return TempWithdrawalCacheFactory(newState);

    case WithdrawalActions.COMMIT_WITHDRAWAL_ERROR:

      if(action.payload.error && !action.payload.error.networkError) { // When its a critical error, remove it from the commit list
        index = newState.withdrawalList.findIndex(wd => wd.cuid == action.payload.withdrawal_id);

        if (newState.withdrawalList[index] && newState.withdrawalList[index].cuid == newState.activeWithdrawalCuid) {
          newState.activeWithdrawalCuid = null;
        }

        if (index > -1) {
          newState.withdrawalList.splice(index, 1);
        }
      }

      newState.has_errored = true;

      return TempWithdrawalCacheFactory(newState);

    case WithdrawalActions.CANCEL_WITHDRAWAL:

      index = newState.withdrawalList.findIndex(wd => wd.cuid == action.payload.withdrawal_id);

      if (newState.withdrawalList[index] && newState.withdrawalList[index].cuid == newState.activeWithdrawalCuid) {
        newState.activeWithdrawalCuid = null;
      }

      if (index > -1) {
        newState.withdrawalList.splice(index, 1);
      }

      return TempWithdrawalCacheFactory(newState);


    default:
      return state;
  }
}




// WEBPACK FOOTER //
// ./src/app/store-management/redux/scans.reducer.ts